module.exports = __webpack_public_path__ + "img/Catharsis.9d9b5860.jpg";